import React from "react";
import {
	Button,
	EmptyModal,
	Select,
	Textarea,
} from "../../../../components/core";

export default function ChangeStatusModal({
	open,
	onClose,
	handleChangeStatus,
	values,
	onSaveStatus,
	userData,
	changesMade,
	setChangesMade,
}) {
	console.log({ values, userData });
	return (
		<EmptyModal open={open} onClose={onClose}>
			<p className="font-bold text-lg text-center">EDIT USER STATUS</p>
			<div className="grid grid-cols-2 gap-2 mt-4">
				<p className="my-auto">
					<b className="text-red-500 mr-2">*</b>
					Status:
				</p>
				<Select
					items={[
						{ value: "1", name: "Active" },
						{ value: "0", name: "Suspended" },
						{ value: "-1", name: "Blocked" },
					]}
					defaultOption={{ value: "-2", name: "-- Select Status --" }}
					onChange={handleChangeStatus}
					name="status"
					value={userData?.userStatus?.toString()}
				/>
				<p className="my-auto">
					<b className="text-red-500 mr-2">*</b>Msg to User(Sent via SMS/APP):
				</p>
				<Textarea
					maxLength={1000}
					onChange={handleChangeStatus}
					name="message1"
					value={values.message1}
				/>
				<p className="my-auto">Private Comments/Reason:</p>
				<Textarea
					maxLength={1000}
					onChange={handleChangeStatus}
					name="message2"
					value={values.message2}
				/>
			</div>
			<div className="grid grid-cols-2 gap-2 mt-4">
				<Button className="p-2" value="Cancel" onClick={onClose} />
				<Button
					className="p-2"
					value="Change"
					onClick={onSaveStatus}
					disabled={!changesMade}
				/>
			</div>
		</EmptyModal>
	);
}
